var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesCountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2266 17.5067C24.0532 18.7467 25.3332 20.4267 25.3332 22.6667V26.6667H30.6666V22.6667C30.6666 19.76 25.9066 18.04 22.2266 17.5067Z",
    fill: "#2B2B5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 16C22.9466 16 25.3332 13.6133 25.3332 10.6667C25.3332 7.72 22.9466 5.33333 19.9999 5.33333C19.3732 5.33333 18.7866 5.46666 18.2266 5.65333C19.3332 7.02666 19.9999 8.77333 19.9999 10.6667C19.9999 12.56 19.3332 14.3067 18.2266 15.68C18.7866 15.8667 19.3732 16 19.9999 16Z",
    fill: "#2B2B5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 16C14.9465 16 17.3332 13.6133 17.3332 10.6667C17.3332 7.72 14.9465 5.33333 11.9998 5.33333C9.05317 5.33333 6.6665 7.72 6.6665 10.6667C6.6665 13.6133 9.05317 16 11.9998 16ZM11.9998 7.99999C13.4665 7.99999 14.6665 9.2 14.6665 10.6667C14.6665 12.1333 13.4665 13.3333 11.9998 13.3333C10.5332 13.3333 9.33317 12.1333 9.33317 10.6667C9.33317 9.2 10.5332 7.99999 11.9998 7.99999Z",
    fill: "#2B2B5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 17.3333C8.43992 17.3333 1.33325 19.12 1.33325 22.6667V26.6667H22.6666V22.6667C22.6666 19.12 15.5599 17.3333 11.9999 17.3333ZM19.9999 24H3.99992V22.68C4.26659 21.72 8.39992 20 11.9999 20C15.5999 20 19.7333 21.72 19.9999 22.6667V24Z",
    fill: "#2B2B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesCountIcon);
export default __webpack_public_path__ + "static/media/employeesCountIcon.9e762973aea92ad0ee88c775f4aa28ec.svg";
export { ForwardRef as ReactComponent };